<template>
  <div class="table-responsive outgoing-cargos">
    <table class="table table-striped">
      <thead>
      <tr>
        <th class="w-5"></th>
        <th class="w-25">{{ $t('shopfloor.teamlead.loading.outgoingCargo.reference') }}</th>
        <th class="w-10 start-time-col">{{ $t('shopfloor.teamlead.loading.outgoingCargo.startTime') }}</th>
        <th class="w-5 start-time-col">{{ $t('shopfloor.unloadingPage.cargoFinishedStatus') }} <i
            @click="showAttentionNeeded = !showAttentionNeeded; saveSetting();" class="far done-toggler"
            :class="showAttentionNeeded ? 'fa-toggle-off' : 'fa-toggle-on'"/></th>
        <th class="w-20 opened-user-col">{{ $t('shopfloor.teamlead.loading.outgoingCargo.openUser') }}</th>
        <th class="w-40 text-center">
          <i @click="showDone = !showDone; saveSetting();" class="far done-toggler"
             :class="showDone ? 'fa-toggle-off' : 'fa-toggle-on'"/>
          <i @click="toggleInfoModal()" class="fal fa-question-circle float-right"/>
        </th>
        <th class="w-20">{{ $t('shopfloor.teamlead.loading.outgoingCargo.etd') }}</th>
      </tr>
      </thead>
      <tbody>
      <tr :key="idx+1" v-for="(outgoing,idx) in sortedCargoList "
          :id="'cargo-id-' + outgoing.id"
          @click="handleOutgoingCargoClick(outgoing)"
          :class="(checkETD(outgoing)  ? 'etd-after' : 'etd-before') + ' clickable-row'">
        <td class="cargo-status-icon">
          <cargo-status-icon :status="outgoing.status" :etd="checkETD(outgoing)"/>
        </td>
        <td>
          <div>{{ outgoing.reference }}</div>
        </td>
        <td v-if="outgoing.startTime && outgoing.progress.loaded">{{
            outgoing.startTime.seconds |
                firebaseTimestampTime
          }}
        </td>
        <td v-else></td>
        <td>
          <template v-if="outgoing.cargo && outgoing.cargo.finished">
            <i v-if="outgoing.status === 'done'" class="fas fa-check green"/>
            <i v-else class="fas fa-times red"/>
          </template>
        </td>
        <td>
          <opened-users :loaded="getLoadedUsers(parseInt(outgoing.id))"
                        :opened="getOpenUsers(parseInt(outgoing.id))"></opened-users>
        </td>
        <td>
          <progress-bar-outgoing-cargo :cargo="outgoing" :progressData="outgoing.progress"/>
        </td>
        <td v-if="outgoing.estimatedTimeOfDeparture">{{ formatOutgoing(outgoing.estimatedTimeOfDeparture) }}
          <i v-if="checkETD(outgoing)" class="fas fa-exclamation-triangle"/>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>


<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import ProgressBarOutgoingCargo from '../../components/ProgressBarOutgoingCargo';
import CargoStatusIcon from '../../components/CargoStatusIcon';
import {openCargo} from "@/mixins/openCargo";
import OpenedUsers from "@/components/loading/OpenedUsers";


var INTERVAL;
export default {
  name: 'team-lead-overview',
  components: {
    OpenedUsers,
    ProgressBarOutgoingCargo,
    CargoStatusIcon
  },
  mixins: [openCargo],
  data() {
    return {
      openedCargo: sessionStorage.getItem('openedCargo'),
      showDone: sessionStorage.getItem('DoneToggleLoading') === 'true' ? true : false,
      showAttentionNeeded: sessionStorage.getItem('AttentionNeededToggleLoading') === 'true' ? true : false,
      tooltip: true,
      currentTime: null
    };
  },
  computed: {
    ...mapGetters('outgoingCargoProgress', ['getProgress']),
    ...mapGetters('users', ['getMeBasic']),
    ...mapGetters('cargo', ['getCargo']),
    sortedCargoList() {
      let filtered = _.filter(_.map(this.getProgress, cargo => {
        cargo.cargo = this.getCargo(cargo.id);
        return cargo;
      }), (cargo) => {
        let differenceInHours = moment().diff(cargo.estimatedTimeOfDeparture.toDate(), 'hours')
        if (differenceInHours < 5) {
          if (this.showAttentionNeeded) {
            if (cargo.cargo && cargo.cargo.finished) {
              return cargo.status !== 'done';
            } else {
              if (this.checkETD(cargo)) {
                return true;
              }
            }
            return false;
          }
          if (!this.showDone) {
            return cargo;
          } else {
            if (cargo.status !== 'done') {
              return cargo;
            }
          }
        }
      });
      return _.orderBy(filtered, [cargo => {
        return cargo.cargo.finished
      }, {'status': 'done'}], ['desc', 'asc']);
    }
  },
  methods: {
    ...mapMutations('orders', [
      'setCurrentProductPicking'
    ]),
    ...mapActions('orders',
        ['setCurrentOrderPicking']
    ),
    ...mapActions('orderProducts',
        ['checkIfProductIsKnownInOrder',
          'incrementAmountPicked',
          'checkAmountPicked']
    ),
    ...mapActions('loading',
        ['updateScannedProduct']
    ),
    handleOutgoingCargoClick(outgoingCargo) {

        this.openCargoOptions(outgoingCargo);

    },
    async openCargoOptions(outgoingCargo) {
      return this.$swal({
        customClass: 'options-modal',
        title: this.$root.$t('whatDoYouWantToDo'),
        html: `<select class="form-control" id="select-action">` +
            `<option value="" selected disabled>Select...</option>` +
            `<option selected value="order-handling">${this.$t('shopfloor.teamlead.orderHandling.orderHandlingOpen')}</option>` +
            `<option value="missing-goods">${this.$t('shopfloor.teamlead.missingGoods.action')}</option>` +
            `</select>`,
        showConfirmButton: true,
        showCloseButton: true,
        preConfirm: function () {
          return new Promise(function (resolve) {
            resolve($('#select-action').val());
          });
        }
      }).then(res => {
        if (res !== null) {
          if (res.value === 'missing-goods') {
            this.openMissingGoods(outgoingCargo.id);
          } else {
            this.openDetailedPage(outgoingCargo, this.getMeBasic.companyId)
          }
        }
      });
    },
    openMissingGoods(cargoId) {
      this.$router.push({path: `/teamlead/missing-goods?cargo=${cargoId}`});
    },
    saveSetting() {
      sessionStorage.setItem('DoneToggleLoading', this.showDone ? 'true' : 'false');
      sessionStorage.setItem('AttentionNeededToggleLoading', this.showAttentionNeeded ? 'true' : 'false');
    },
    formatOutgoing(departure) {
      return moment(departure.toDate()).format('DD/MM HH:mm')
    },
    checkETD(outgoing) {
      let now = this.currentTime;
      if (now && outgoing.estimatedTimeOfDeparture)
        return now.isAfter(moment(new Date(outgoing.estimatedTimeOfDeparture.seconds * 1000))) && outgoing.status != 'done';
    },
    openDetailedPage(cargo, companyId) {

        sessionStorage.setItem('openedCargo', JSON.stringify(cargo));
        this.$router.push({
          name: 'teamlead-order-handling-loading',
          params: {cargo: cargo}
        });

    },
    toggleInfoModal() {
      let html = '<div class="legend-block">' +
          '<ul>' +
          '<li><div class="block"><i @click="showDone = !showDone" class="far fa-toggle-off done-toggler"></i></div>' + this.$root.$t('shopfloor.teamlead.loading.legend.toggle') + '</li>' +
          '<li><div class="block green"></div>' + this.$root.$t('shopfloor.teamlead.loading.legend.green') + '</li>' +
          '<li><div class="block orange"></div>' + this.$root.$t('shopfloor.teamlead.loading.legend.orange') + '</li>' +
          '<li><div class="block blue"></div>' + this.$root.$t('shopfloor.teamlead.loading.legend.blue') + '</li>' +
          '<li><div class="block white"></div>' + this.$root.$t('shopfloor.teamlead.loading.legend.white') + '</li>' +
          '</ul>' +
          '</div>';

      this.$swal({
        customClass: 'm-swal-load-unload',
        width: '80%',
        allowEscapeKey: true,
        allowOutsideClick: true,
        title: this.$root.$t('shopfloor.teamlead.loading.legendTitle'),
        html: html,
        showConfirmButton: true,
        cancelButtonText: this.$root.$t('ui.close')
      });
    },
    scrollProductIntoView(id) {
      // Inteval to wait for rows to be rendered, otherwise the row cant be found
      let interval = setInterval(() => {
        let elementToScrollTo = document.getElementById('cargo-id-' + id);
        if (elementToScrollTo) {
          clearInterval(interval);
          let headerOffset = 60;
          let elementPosition = elementToScrollTo.getBoundingClientRect().top;
          let offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        }
      }, 500);
    },
  },
  async beforeRouteLeave(to, from, next) {
    clearInterval(INTERVAL);
    await this.$store.dispatch('resetStoreModules', ['outgoingCargoProgress']);
    next();
  },
  watch: {
    sortedCargoList(newV, oldV) {
      if (!_.isEqual(newV, oldV)) {
        if (sessionStorage.getItem('lastVisitedPage') === 'teamlead-order-handling-loading' && this.openedCargo) {
          const cargo = JSON.parse(this.openedCargo);
          this.scrollProductIntoView(cargo.id);
          this.openedCargo = '';
        }
      }
    }
  },
  async created() {
    this.openedCargo = sessionStorage.getItem('openedCargo');
    sessionStorage.removeItem('openedCargo');
    await this.$store.dispatch('initDataForPage', ['outgoingCargoProgress']);
    INTERVAL = setInterval(() => {
      this.currentTime = moment();
    }, 1000);
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      sessionStorage.setItem('lastVisitedPage', from.name);
    });
  }
};


</script>

<style lang="scss" scoped>
.clickable-row {
  cursor: pointer;
}

.table thead th {
  width: auto;
}

.opened-user-col {
  width: 20% !important;
}

.start-time-col {
  width: 10% !important;
}


.green {
  color: #00b954;
}

.red {
  color: red;
}
</style>

